const sanitizeString = str => {
  str = str.replace(/[^a-z0-9 \.,_-]/gim, "");
  return str.trim();
};
export default sanitizeString;